<app-selected-filters-cont
  [viewSelectedFilters]="viewSelectedFilters$ | async"
  [inFilterBar]="inFilterBar"
  [isMobile]="isMobile">
  <ul selectedFilters="selectedFilters">
    <li *ngIf="hasHotelNameSearchInputFilter">
      <app-filter-bar-tag
        [class.active]="true"
        [isActive]="true"
        [isMultipleSelection]="false"
        [label]="hotelNameSearch"
        (clickEvent)="removeInputFilter()">
      </app-filter-bar-tag>
    </li>
    <li *ngIf="hasTotalDiscountPercentageFilter">
      <app-filter-bar-tag
        [class.active]="true"
        [isActive]="true"
        [isMultipleSelection]="false"
        [label]="totalDiscountPercentageText"
        (clickEvent)="removeDiscountFilter()">
      </app-filter-bar-tag>
    </li>
    <ng-container *ngFor="let filter of filters">
      <ng-container *ngIf="isRangeFilter(filter)">
        <ng-container
          *ngTemplateOutlet="rangeFilterTemplate; context: { filter: filter }">
        </ng-container> 
      </ng-container>
      <ng-container *ngIf="checkboxFilterTypes(filter)">
        <ng-container
          *ngTemplateOutlet="checkboxFilterTemplate; context: { filter: filter }">
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isExclusiveOffer(filter)">
        <ng-container
          *ngTemplateOutlet="exclusiveOfferFilterTemplate; context: { filter: filter }">
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #checkboxFilterTemplate let-filter='filter'>
      <ng-container *ngFor="let item of filter.value">
        <li *ngIf="checked(item, filter.type, isCheckboxFilter(filter))">
          <app-filter-bar-tag
            [class.active]="true"
            [isActive]="true"
            [isMultipleSelection]="false"
            [label]="getCheckboxLabel(item, filter.type)"
            (clickEvent)="removeCheckboxFilter(item, filter.type, isCheckboxFilter(filter))">
          </app-filter-bar-tag>
        </li>
      </ng-container>
    </ng-template>
    
    <ng-template #rangeFilterTemplate let-filter='filter'>
      <li *ngIf="checkedRanges(filter.type) as range">
        <app-filter-bar-tag
          [class.active]="true"
          [isActive]="true"
          [isMultipleSelection]="false"
          [label]="(getItemLabel(filter.type) | transloco) + ': ' + (range[0] | priceAbbreviation) + ' - ' + (range[1] | priceAbbreviation)"
          (clickEvent)="removeRangeFilter(filter.type)">
        </app-filter-bar-tag>
      </li>
    </ng-template>
    
    <ng-template #exclusiveOfferFilterTemplate let-filter='filter'>
      <li *ngIf="hasExclusiveOffer">
        <app-filter-bar-tag
          [class.active]="true"
          [isActive]="true"
          [isMultipleSelection]="false"
          [label]="exclusiveLabel(filter)"
          [icon]="exclusiveIconTag(filter)"
          (clickEvent)="removeExclusiveOfferFilter()">
        </app-filter-bar-tag>
      </li>
    </ng-template>
  </ul>
</app-selected-filters-cont>


